export default {
  REQUEST_USER: 'user/REQUEST_USER',
  REQUEST_USER_DETAILS: 'user/REQUEST_USER_DETAILS',
  REQUEST_USER_NAME: 'user/REQUEST_USER_NAME',
  SET_USER: 'user/SET_USER',
};
